import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Fragment } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FREE_TIER_MAX_USERS = 2;

/* The backend returns Integer.MAX_VALUE as maxPurchasableUsers for a tier with
 * no touchless seat cap (Professional/Enterprise) — i.e. unlimited users. */
const UNLIMITED_TOUCHLESS_QUANTITY = 2 ** 31 - 1;
const CreditsValue = ({
  credits
}) => /*#__PURE__*/_jsx(FormattedNumber, {
  value: credits,
  abbreviate: true,
  maxFractionDigits: 2,
  abbreviateThreshold: 1000
});
export const HsocMerchCardSubtext = ({
  tierName,
  maxPurchasableUsers,
  currentPlan
}) => {
  const items = [];
  if (currentPlan) {
    if (currentPlan.users >= 1) {
      items.push({
        key: 'users',
        copy: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hsocPricingPage.merchCard.subtext.users",
          options: {
            count: currentPlan.users
          }
        })
      });
    }
    items.push({
      key: 'credits',
      copy: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "hsocPricingPage.merchCard.subtext.credits",
        options: {
          credits: /*#__PURE__*/_jsx(CreditsValue, {
            credits: currentPlan.credits
          })
        }
      })
    });
  } else {
    const cap = tierName === 'FREE' ? FREE_TIER_MAX_USERS : maxPurchasableUsers;
    /* undefined cap = unknown (missing product data): skip the users line
     * rather than asserting a limit we don't have. */
    if (cap !== undefined) {
      items.push({
        key: 'users',
        copy: cap >= UNLIMITED_TOUCHLESS_QUANTITY ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hsocPricingPage.merchCard.subtext.unlimitedUsers"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hsocPricingPage.merchCard.subtext.upToUsers",
          options: {
            count: cap
          }
        })
      });
    }
  }
  if (items.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "100",
    "data-selenium-id": `hsoc-merch-card-subtext-${tierName.toLowerCase()}`,
    children: /*#__PURE__*/_jsx(Flex, {
      flexDirection: "row",
      alignItems: "center",
      flexWrap: "wrap",
      children: items.map(({
        key,
        copy
      }, index) => /*#__PURE__*/_jsxs(Fragment, {
        children: [index > 0 && /*#__PURE__*/_jsx(Text, {
          marginInline: "100",
          display: "inline-block",
          color: "fill-brand-default",
          "aria-hidden": "true",
          children: "\u2022"
        }), /*#__PURE__*/_jsx(Text, {
          display: "inline-block",
          typography: "detail-100",
          color: "text-core-default",
          children: copy
        })]
      }, key))
    })
  });
};